export const AUTH_QUERY_KEY = ["authCheck"];
